module.exports = "<h2>My Heroes</h2>\r\n\r\n<ul class=\"heroes\">\r\n  <li *ngFor=\"let hero of heroes\"\r\n      [class.selected]=\"hero === selectedHero\"\r\n      (click)=\"onSelect(hero)\">\r\n    <span class=\"badge\">{{hero.id}}</span> {{hero.name}}\r\n  </li>\r\n</ul>\r\n\r\n<app-hero-detail [hero]=\"selectedHero\"></app-hero-detail>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/heroes/heroes.component.html
// module id = ./src/app/components/heroes/heroes.component.html
// module chunks = main